import { useEffect, useRef } from "react";
import { publicConfig } from "../config/public";

export function TurnstileWidget({ onToken }: { onToken(token: string): void }) {
  const container = useRef<HTMLDivElement>(null);
  const siteKey = publicConfig.turnstileSiteKey;
  useEffect(() => {
    if (!siteKey || !container.current) return;
    const host = container.current;
    let widgetId: string | undefined;
    const render = () => {
      if (window.turnstile && !widgetId) {
        widgetId = window.turnstile.render(host, {
          sitekey: siteKey,
          callback: onToken,
          "expired-callback": () => onToken(""),
          theme: "dark",
        });
      }
    };
    const existing = document.querySelector<HTMLScriptElement>(
      "script[data-a2p-turnstile]",
    );
    if (existing) render();
    else {
      const script = document.createElement("script");
      script.src =
        "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.dataset.a2pTurnstile = "true";
      script.addEventListener("load", render, { once: true });
      document.head.appendChild(script);
    }
    return () => {
      if (widgetId && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [onToken, siteKey]);
  if (!siteKey)
    return (
      <p className="text-sm text-amber-200">
        Configure VITE_TURNSTILE_SITE_KEY before using production assessment
        mode.
      </p>
    );
  return <div ref={container} aria-label="Bot protection verification" />;
}
